<!-- eslint-disable -->
<template>
    <span 
      v-if="isInitiailized === true"
      class="{G_default_modal_title_text: dontUseDefaultFontSize !== true}" 
    >
        <c21-org-parents-label 
          v-if="showOrgParents == true && actualOrgUid !== null && actualOrgUid !== undefined"
          :orgUid="actualOrgUid"
          :stopOrgUid="ExcludeOrgParentsUid"
        ></c21-org-parents-label>

        
        <c7-org-name-label
          v-if="actualOrgUid !== null && actualOrgUid !== undefined &&
                hideOrgName !== true"
          :orgUid="actualOrgUid">
        </c7-org-name-label>
        
        <span 

        v-if="actualOrgUid !== null && actualOrgUid !== undefined &&
              actualSystemUid !== null && actualSystemUid !== undefined &&
              hideOrgName !== true && hideSystemName !== true"
        > > </span>

        <c9-sys-name-label
          v-if="actualSystemUid !== null && actualSystemUid !== undefined && 
                hideSystemName !== true"
          :systemUid="actualSystemUid">
        </c9-sys-name-label>
        <span 
          v-if="actualSystemUid !== null && actualSystemUid !== undefined &&
              actualObjectUid !== null && actualObjectUid !== undefined &&
              hideSystemName !== true"
         
        > > </span>
            
        <c11-object-name-label
          v-if="actualObjectUid !== null && actualObjectUid !== undefined && 
                hideObjectName !== true"
          :objectUid="actualObjectUid">
        </c11-object-name-label>

        <span 
          v-if="actualObjectUid !== null && actualObjectUid !== undefined &&
                actualObjectAttributeUid !== null && actualObjectAttributeUid !== undefined && 
                hideObjectName !== true"
        > > </span>


        <c13-object-attribute-name-label
          v-if="actualObjectAttributeUid !== null && actualObjectAttributeUid !== undefined &&
                hideObjectAttributeName !== true"
          :objectAttributeUid="actualObjectAttributeUid"> 
        </c13-object-attribute-name-label>
    </span>
</template>

<script>
/* eslint-disable */
/* the reason  '../labels/' is before the files in the same directory is to prevent NPM 
compile warnings as it sees ./X as different than ../label/X if when this component is put in 
another component that uses one of the children components in this componenet
*/
import c21OrgParentsLabel from "../Labels/c21OrgParentsLabel";
import c7OrgNameLabel from "../Labels/c7OrgNameLabel";
import c9SysNameLabel from "../Labels/c9SysNameLabel";
import c11ObjectNameLabel from "../Labels/c11ObjectNameLabel";
import c13ObjectAttributeNameLabel from "../Labels/c13ObjectAttributeNameLabel";

export default {
  name: "c22FullPathLabel",
  components: {
    c21OrgParentsLabel,
    c7OrgNameLabel,
    c9SysNameLabel,
    c11ObjectNameLabel,
    c13ObjectAttributeNameLabel,
  },
  props: [
    "ExcludeOrgParentsUid",
    "showOrgParents",
    "orgUid",
    "systemUid",
    "objectUid",
    "objectAttributeUid",
    "hideObjectName",
    "hideSystemName",
    "hideOrgName",
    "hideObjectAttributeName",
    "dontUseDefaultFontSize"
  ],
  data: function() {
    return {
      actualOrgUid: null,
      actualSystemUid: null,
      actualObjectUid: null,
      actualObjectAttributeUid: null,
      objectLookupDict: {},
      systemLookupDict: {},
      orgLookupDict: {},
      isInitiailized: false,
      initStepsProgress: 0,
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.startListener();
    });
  },
  methods: {
    startListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.vue_instance.$data.watchdog.watchdogDbConnected === true) {
        this.objectLookupDict = window.G_watchdog_data.IV_object_attribute_joins_reverse_lookup;
        this.systemLookupDict = window.G_watchdog_data.IV_system_object_joins_reverse_lookup;
        this.orgLookupDict = window.G_watchdog_data.IV_system_org_joins;
        this.actualOrgUid = this.orgUid;
        this.actualSystemUid = this.systemUid;

        if (typeof this.objectUid !== "string" && typeof this.objectAttributeUid === "string") {
          this.actualObjectUid = this.objectAttributeUid.replace("obj_atr_", "obj_").split("-")[0];
        } else {
          this.actualObjectUid = this.objectUid;
        }
        this.lookupMetaData();
      } else {
        setTimeout(this.startListener, 200);
      }
    },
    lookupMetaData() {
      this.actualObjectAttributeUid = this.objectAttributeUid;

      if (
        typeof this.objectAttributeUid === "string" &&
        typeof this.systemUid !== "string" &&
        this.initStepsProgress < 1
      ) {
        window.G_watchdog_data.bi7InitObjectAttributeParentSystemListener(
          this.actualObjectUid,
          this.objectAttributeUid
        );
        this.initStepsProgress = 1;
        setTimeout(this.lookupMetaData, 200);
        return;
      }

      if (
        typeof this.actualObjectAttributeUid === "string" &&
        typeof this.actualObjectUid !== "string" &&
        this.initStepsProgress < 2
      ) {
        if (this.actualObjectAttributeUid in this.objectLookupDict) {
          this.actualObjectUid = this.objectLookupDict[this.actualObjectAttributeUid];
          this.initStepsProgress = 2;
        } else {
          setTimeout(this.lookupMetaData, 200);
          return;
        }
      }

      if (typeof this.actualObjectUid === "string" && typeof this.systemUid !== "string" && this.initStepsProgress < 3) {
        if (this.actualObjectUid in this.systemLookupDict) {
          this.actualSystemUid = this.systemLookupDict[this.actualObjectUid];
          this.initStepsProgress = 3;
        } else {
          setTimeout(this.lookupMetaData, 200);
          return;
        }
      }

      if (typeof this.actualSystemUid === "string" && typeof this.orgUid !== "string" && this.initStepsProgress < 4) {
        if (this.actualSystemUid in this.orgLookupDict) {
          this.actualOrgUid = this.orgLookupDict[this.actualSystemUid];
          this.initStepsProgress = 4;
        } else {
          setTimeout(this.lookupMetaData, 200);
          return;
        }
      }
      this.isInitiailized = true;
    },
  },
  watch: {
    objectLookupDict() {
      if (this.initStepsProgress === 4) {
        this.lookupMetaData();
      }
    },
    systemLookupDict() {
      if (this.initStepsProgress === 4) {
        this.lookupMetaData();
      }
    },
    orgLookupDict() {
      if (this.initStepsProgress === 4) {
        this.lookupMetaData();
      }
    },
  },
  beforeDestroy() {
    if (this.objectAttributeUid) {
      window.G_watchdog_data.bi7UnsubscribeSpecificListener('object_attribute_parent_system', this.objectAttributeUid);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Labels/c22FullPathLabel.vue